import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { set } from 'cypress/types/lodash';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { shippnpilotReviews } from 'src/app/shared/contents/shippn-reviews/shippn-reviews-review';
import { register } from 'swiper/element/bundle';

@Component({
  selector: 'b2b-main',
  templateUrl: 'b2b-main.component.html',
  styleUrls: ['b2b-main.component.css'],
})
export class B2bMainComponent implements OnInit, AfterViewInit {
  lang: string = 'en';
  token: string = '';
  allCountries: any[] = [];
  shippnpilotReviews = shippnpilotReviews;
  form = new UntypedFormGroup({
    countryFrom: new UntypedFormControl('AU', Validators.required),
    countryTo: new UntypedFormControl('TR', Validators.required),
    weight: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(0.5),
    ]),
    width: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(0.5),
    ]),
    height: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(0.5),
    ]),
    length: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(0.5),
    ]),
    weightUnit: new UntypedFormControl('kg', Validators.required),
    dimensionUnit: new UntypedFormControl('cm', Validators.required),
    dimensionMetric: new UntypedFormControl('kg', Validators.required),
  });
  hasCourierOptions: boolean = false;
  courierData: any = [];
  constructor(
    private apiService: SignupService,
    private toastr: ToastrService,
    private router: Router,
    private watcherService: WatcherService
  ) {}

  ngOnInit(): void {
    this.initSwiper();
    this.apiService.getAllCountries().subscribe((list) => {
      this.allCountries = list['data'];

      let hostCountries = list['data'];

      const countriesVIP = [
        'United States of America',
        'United Kingdom',
        'Australia',
        'Canada',
        'Germany',
        'Japan',
        'France',
        'Netherlands',
        'Italy',
        'Sweden',
      ];
      this.allCountries = hostCountries.sort((a, b) => {
        const indexA = countriesVIP.findIndex(
          (vip) => vip.toLowerCase() === a.name.toLowerCase()
        );
        const indexB = countriesVIP.findIndex(
          (vip) => vip.toLowerCase() === b.name.toLowerCase()
        );

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return a.name.localeCompare(b.name);
        }
      });

      this.allCountries.forEach((country) => {
        country.code = country.code.toUpperCase();  
      })





    });
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }
  initSwiper() {
    const swiperBannerEl = document.getElementById('shippn-main-banner-swiper');
    Object.assign(swiperBannerEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      nextButton: '#mainBannerNext',
      prevButton: '#mainBannerPrev',
      breakpoints: {
        '768': {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
        '992': {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
        '1200': {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
      },
    });

    const shippnpilotReviewsSwiperEl = document.getElementById(
      'shippnpilotReviewsSwiper'
    );
    const tprsNextEl = document.getElementById('shippnpilotReviewsSwiper-next');
    const tprsPrevEl = document.getElementById('shippnpilotReviewsSwiper-prev');

    tprsNextEl.addEventListener('click', () => {
      shippnpilotReviewsSwiperEl['swiper'].slideNext();
    });
    tprsPrevEl.addEventListener('click', () => {
      shippnpilotReviewsSwiperEl['swiper'].slidePrev();
    });

    Object.assign(shippnpilotReviewsSwiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      nextButton: '#shippnpilotReviewsSwiper-next',
      prevButton: '#shippnpilotReviewsSwiper-prev',
      breakpoints: {
        '420': {
          spaceBetween: 10,
          slidesPerView: 'auto',
        },
        '576': {
          spaceBetween: 10,
          slidesPerView: 'auto',
        },
        '768': {
          spaceBetween: 25,
          slidesPerView: 'auto',
        },
      },
    });

    setTimeout(() => {
      register();
    }, 100);
  }
  ngAfterViewInit(): void {}
  changeFromCountry() {}
  changeToCountry() {}
  changeDimensionsUnit(val) {
    if (val === 'kg') {
      this.form.controls.dimensionMetric.setValue('kg');
      this.form.controls.weightUnit.setValue('kg');
      this.form.controls.dimensionUnit.setValue('cm');
    } else {
      this.form.controls.dimensionMetric.setValue('lbs');
      this.form.controls.weightUnit.setValue('lbs');
      this.form.controls.dimensionUnit.setValue('inch');
    }
  }
  b2bMainToSignUpPayload;

  calculatePrice() {
    if (this.checkCalculateForm()) {
      const payload = {
        country_to: this.form.value.countryFrom,
        country_from: this.form.value.countryTo,
        weight: this.form.value.weight ?? 0,
        weight_unit: this.form.value.weightUnit,
        height: this.form.value.height ?? 0,
        width: this.form.value.width ?? 0,
        length: this.form.value.length ?? 0,
        dimension_unit: this.form.value.dimensionUnit,
      };
      this.b2bMainToSignUpPayload = payload;
      this.apiService.getB2BPriceList(this.token, payload).subscribe({
        next: (calculateRes) => {
          if (calculateRes['data'].length > 0) {
            this.hasCourierOptions = true;

            const filteredData = calculateRes['data'].map((item) => {
              return {
                ...item,
                amount: item.amount.toFixed(2)
              };
            });
            this.courierData = filteredData;
            if(this.courierData.length > 0) {
              setTimeout(()=> {
                window.document.getElementById('b2b-price-calculation-section').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
              }, 400)
            }
          } else if(calculateRes['result']['status'] !== 200){
            this.toastr.error(calculateRes['result']['message'], 'Error');
            this.hasCourierOptions = false;
            this.courierData = [];
          } else { 
            this.toastr.error('No courier options available', 'Error');
            this.hasCourierOptions = false;
            this.courierData = [];
          }
        },
        error: (err) => {},
      });
    } else {
      this.toastr.error('Please fill all fields', 'Error');
    }
  }

  checkCalculateForm() {
    if (
      this.form.value.weight > 0 &&
      this.form.value.height > 0 &&
      this.form.value.width > 0 &&
      this.form.value.length > 0
    ) {
      return true;
    } else {
      if (this.form.controls.weight.status == 'INVALID') {
        this.form.controls.weight.markAsTouched();
      }
      if (this.form.controls.height.status == 'INVALID') {
        this.form.controls.height.markAsTouched();
      }
      if (this.form.controls.width.status == 'INVALID') {
        this.form.controls.width.markAsTouched();
      }
      if (this.form.controls.length.status == 'INVALID') {
        this.form.controls.length.markAsTouched();
      }
    }

    return false;
  }
  trackByIndex(index: number): any {
    return index;
  }
  arrayMaker(n) {
    return Array(n);
  }

  goToB2BSignUp() {
    localStorage.setItem(
      'b2bMainToSignUpPayload',
      JSON.stringify(this.b2bMainToSignUpPayload)
    );
    this.router.navigate(['/','b2b', 'create-shipment']);
  }

  inputFocus(field: string): void {
    const control = this.form.get(field);
    if (control?.value === 0 || control?.value === '0') {
      control.setValue('');
    }
  }

  inputBlur(field: string): void {
    const control = this.form.get(field);
    const value = control?.value;
    if (!value || value.toString().trim() === '') {
      control.setValue(0);
    } else {
      control.setValue(parseFloat(value));
    }
  }
}
